import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab, Box, Badge } from '@material-ui/core';

import Acessorios from '../childrens/acessorios/.mixins';
import Moveis from '../childrens/moveis/.mixins';

//css
import TabsCss from './styles';
const useStyles = TabsCss();

const TabPanel = (props) => {
  const { children, value, index, marginBox, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={!isNaN(parseInt(marginBox)) ? marginBox : 3}>
          {children}
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const LabelTab = ({numberNotifications,title}) => {
  return (
    <>
      <Badge badgeContent={numberNotifications} color="error">
        {title}
      </Badge>
    </>
  );
};

export default (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const { categoriaFornecedor } = props.state;
  // const isFornecedorDeAmbos = !!categoriaFornecedor.moveis && !!categoriaFornecedor.acessorios;
  
  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
            value={props.state.valueTab}
            onChange={props.handlerChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            aria-label="Tabs Qualidade"
        >
          {categoriaFornecedor.includes('acessorios') && (  
            <Tab
              label={
                <LabelTab
                  numberNotifications={0}
                  title={"Acessórios"}
                />
              }
              value={'acessorios'}
            />
          )}
          
          {categoriaFornecedor.includes('moveis') && (
            <Tab
              label={
                <LabelTab
                  numberNotifications={props.state.qtdAgendamentoPendentes}
                  title={"Móveis"}
                />
              }
              value={'moveis'}
            />
          )}
        </Tabs>
        
      </AppBar>
         {categoriaFornecedor.includes('acessorios') && (
          <TabPanel value={props.state.valueTab} index={'acessorios'} dir={theme.direction}>
            <Acessorios {...props} />
          </TabPanel>
        )}
        
        {categoriaFornecedor.includes('moveis') && (
          <TabPanel value={props.state.valueTab} index={'moveis'} dir={theme.direction}>
            <Moveis {...props} />
          </TabPanel>
        )}
    </div>
  );
};
